import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import LanguagePill from "@/components/LanguagePill";

const COPY = {
  en: {
    tagline: "Walk your life with awareness.",
    sub: <>A contemplative companion through<br/> the Vedic chapters of your life.</>,
    continue: "Continue with Google",
    or_email: "or continue with email",
    legal_pre: "By continuing, you agree to our",
    privacy: "Privacy Policy",
    and: "and",
    terms: "Terms",
  },
  hi: {
    tagline: "जीवन को जागरूकता से चलें।",
    sub: <>आपके जीवन के वैदिक अध्यायों के<br/>लिए एक चिंतनशील साथी।</>,
    continue: "Google से जारी रखें",
    or_email: "या ईमेल से जारी रखें",
    legal_pre: "जारी रखकर आप हमारी",
    privacy: "गोपनीयता नीति",
    and: "और",
    terms: "शर्तों",
  },
};

export default function Welcome() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { lang } = useLang();
  const c = COPY[lang === "hi" ? "hi" : "en"];

  if (!loading && user) {
    // Already authed
    setTimeout(() => navigate(user.onboarding_complete ? "/app/today" : "/onboarding/language", { replace: true }), 100);
  }

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: "var(--vedari-cream)", color: "var(--vedari-ink)" }}>
      {/* Top bar — language toggle */}
      <div className="flex justify-end px-6 pt-6">
        <LanguagePill />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center px-8 animate-gentle-rise">
        <div className="w-16 h-16 mb-10 rounded-full flex items-center justify-center" style={{ border: "1.5px solid var(--vedari-gold)" }}>
          <span className="font-display text-3xl" style={{ color: "var(--vedari-gold)" }}>व</span>
        </div>
        <h1 className="font-display text-5xl mb-4 tracking-tight" style={{ color: "var(--vedari-ink)" }} data-testid="welcome-title">
          Vedari
        </h1>
        <p className="text-body-lg text-center max-w-xs leading-relaxed font-serif" style={{ color: "var(--vedari-ink-soft)" }} data-testid="welcome-tagline">
          {c.tagline}
        </p>
        <div className="ornate-divider w-48 my-12">
          <span className="text-xs tracking-[0.3em]">॥</span>
        </div>
        <p className="text-body-sm text-center max-w-xs" style={{ color: "var(--vedari-ink-soft)" }}>
          {c.sub}
        </p>
      </div>

      <div className="px-8 pb-12 space-y-3 max-w-md mx-auto w-full">
        <button
          onClick={handleGoogle}
          data-testid="continue-with-google-btn"
          className="vedari-btn-primary w-full"
        >
          {c.continue}
        </button>
        <button
          onClick={() => navigate("/auth/email")}
          data-testid="continue-with-email-btn"
          className="vedari-btn-tertiary w-full"
        >
          {c.or_email}
        </button>
        <p className="text-center text-caption pt-3" style={{ color: "var(--vedari-ink-soft)" }}>
          {c.legal_pre} <a href="/privacy" className="underline" style={{ color: "var(--vedari-slate)" }}>{c.privacy}</a> {c.and} <a href="/terms" className="underline" style={{ color: "var(--vedari-slate)" }}>{c.terms}</a>.
        </p>
      </div>
    </div>
  );
}
